import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "id-iden" }
const _hoisted_3 = { class: "v-stack-tabs" }
const _hoisted_4 = ["onMousedown"]
const _hoisted_5 = { class: "tab-name" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.children)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: _ctx.uid.toString(),
        id: _ctx.id.toString(),
        style: _normalizeStyle('min-width:250px; min-height:150px; flex:' + _ctx.componentState.flex),
        class: "v-stack-container"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.id), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([{
					active: _ctx.activeTab == i,
					activeVis: _ctx.activeView == child.componentState.viewId
				}, "stack-tab"]),
              onMousedown: ($event: any) => (
					_ctx.dragStart($event, child.id),
						(_ctx.activeTab = i),
						_ctx.panelStore.SET_ACTIVE_VISUALIZER(child.id, child.componentState.viewId)
				),
              key: i
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`${child.componentName}`)), 1),
              (_ctx.visualizers.length > 1)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (_ctx.removeComponent(child)), ["stop"]),
                    class: "fal fa-times"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ], 42, _hoisted_4))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, i) => {
          return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(child.component ? 'LayoutComponent' : 'LayoutContainer'), {
            stacked: "",
            key: i,
            type: child.type,
            id: child.id,
            componentState: child.componentState,
            componentName: child.componentName,
            children: child.children || [],
            component: child.component
          }, null, 8, ["type", "id", "componentState", "componentName", "children", "component"])), [
            [_vShow, _ctx.activeTab == i]
          ])
        }), 128))
      ], 12, _hoisted_1))
    : _createCommentVNode("", true)
}